<template>
  <div>
    <v-dialog ref="dialog" v-model="dialog" max-width="600">
      <v-card rounded="lg" class="cdlg">
        <div class="cdlg__head">
          <div class="cdlg__eyebrow">{{ $t("classEdit.eyebrow") }}</div>
          <div class="cdlg__title">{{ item.name }}</div>
        </div>

        <v-card-text class="cdlg__body">
          <div class="cdlg__facts">
            <div class="cdlg__fact">
              <span class="cdlg__fact-k">{{ $t("classEdit.start") }}</span>
              <span class="cdlg__fact-v">{{ formatDate(item.start) }}</span>
            </div>
            <div class="cdlg__fact">
              <span class="cdlg__fact-k">{{ $t("classEdit.end") }}</span>
              <span class="cdlg__fact-v">{{ formatDate(item.end) }}</span>
            </div>
            <div v-if="item.link" class="cdlg__fact cdlg__fact--stack">
              <span class="cdlg__fact-k">{{ $t("classEdit.accessLink") }}</span>
              <a class="cdlg__link" :href="item.link" target="_blank">{{
                item.link
              }}</a>
            </div>
          </div>
        </v-card-text>

        <div class="cdlg__actions cdlg__actions--split">
          <v-btn
            text
            class="cdlg__btn"
            color="var(--dk-ink, #231A2E)"
            @click="late"
          >
            <v-icon left size="18">mdi-pencil-outline</v-icon>
            {{ $t("classEdit.modify") }}
          </v-btn>
          <v-btn
            depressed
            rounded
            dark
            class="cdlg__btn"
            color="#A826E1"
            @click="confirm"
          >
            <v-icon left size="18">mdi-check</v-icon>
            {{ $t("classEdit.teach") }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { format } from "date-fns";
export default {
  name: "class-edit-dialog",
  props: {
    item: {
      type: Object,
    },
  },
  data: () => {
    return {
      dialog: false,
      postpone: false,
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    confirm() {
      this.$emit("confirm", this.item);
    },
    formatDate(date) {
      return format(date, this.$t("formats.dateTime"));
    },
    late() {
      this.$emit("adiar", this.item);
    },
  },
};
</script>
<style scoped>
.cdlg {
  --accent: var(--dk-grape, #a826e1);
  border-radius: 20px !important;
  color: var(--dk-ink, #231a2e);
}
.cdlg__head {
  padding: 22px 24px 4px;
}
.cdlg__eyebrow {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--accent);
}
.cdlg__title {
  margin-top: 4px;
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1.2;
  color: var(--dk-ink, #231a2e);
}
.cdlg__body {
  padding-top: 14px;
  color: var(--dk-ink, #231a2e);
}
.cdlg__facts {
  display: grid;
  gap: 12px;
}
.cdlg__fact {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
}
.cdlg__fact--stack {
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.cdlg__fact-k {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--dk-muted, #6b6472);
}
.cdlg__fact-v {
  font-size: 0.92rem;
  font-weight: 600;
  color: var(--dk-ink, #231a2e);
  font-variant-numeric: tabular-nums;
}
.cdlg__link {
  font-size: 0.86rem;
  font-weight: 600;
  color: var(--accent);
  word-break: break-all;
}
.cdlg__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 20px 18px;
}
.cdlg__actions--split {
  justify-content: space-between;
}
.cdlg__btn {
  text-transform: none;
  letter-spacing: normal;
  font-weight: 700;
}
</style>
